import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { selectCars } from "../../../redux/car/car-slice";
import expenseCategoryService from "../services/expenseService";

const useExpenseFormData = () => {
    const cars = useSelector(selectCars);

    const [categories, setCategories] = useState([]);

    const [loading, setLoading] = useState(true);

    const [error, setError] = useState(null);

    useEffect(() => {

        let mounted = true;

        const loadData = async () => {

            try {

                const [

                    categoriesData,

                ] = await Promise.all([

                    expenseCategoryService.getExpenseCategories(),

                ]);

                if (!mounted) return;

                // setCars(carsData);

                setCategories(categoriesData);

            }

            catch (err) {

                console.error(err);

                if (mounted) {

                    setError(err);

                }

            }

            finally {

                if (mounted) {

                    setLoading(false);

                }

            }

        };

        loadData();

        return () => {

            mounted = false;

        };

    }, []);

    return {

        cars,

        categories,

        loading,

        error,

    };

};

export default useExpenseFormData;